(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/components/customer-address-information.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/components/customer-address-information.js');
"use strict";


const useCustomerPreferences = svs.ticketsOrderHome.hooks.useCustomerPreferences;
const _svs$ticketsOrderHome = svs.ticketsOrderHome.utils,
  formatCustomerPreferenceAddressInfo = _svs$ticketsOrderHome.formatCustomerPreferenceAddressInfo,
  isCustomerPreferenceAddressInfoMissing = _svs$ticketsOrderHome.isCustomerPreferenceAddressInfoMissing;
const Loader = svs.ticketsOrderHome.components.Loader;
const CustomerAddressInformationComponent = _ref => {
  let className = _ref.className,
    loading = _ref.loading,
    error = _ref.error,
    data = _ref.data,
    _ref$LoaderComponent = _ref.LoaderComponent,
    LoaderComponent = _ref$LoaderComponent === void 0 ? Loader : _ref$LoaderComponent;
  if (loading) {
    return LoaderComponent ? React.createElement(LoaderComponent, null) : null;
  }
  if (error) {
    return React.createElement("div", {
      className: className
    }, React.createElement("p", {
      className: "f-content margin-bottom-0"
    }, "Adress kunde inte h\xE4mtas."));
  }
  if (isCustomerPreferenceAddressInfoMissing(data)) {
    return React.createElement("div", {
      className: className
    }, React.createElement("p", {
      className: "f-content margin-bottom-0"
    }, "Adress saknas."));
  }
  const _formatCustomerPrefer = formatCustomerPreferenceAddressInfo(data),
    fullName = _formatCustomerPrefer.fullName,
    addressRow1 = _formatCustomerPrefer.addressRow1,
    addressRow2 = _formatCustomerPrefer.addressRow2,
    email = _formatCustomerPrefer.email,
    emailVerified = _formatCustomerPrefer.emailVerified;
  return React.createElement("div", {
    className: "data-hj-suppress ".concat(className)
  }, React.createElement("p", {
    className: "f-content margin-bottom-0"
  }, fullName), React.createElement("p", {
    className: "f-content margin-bottom-0"
  }, addressRow1), React.createElement("p", {
    className: "f-content margin-bottom-0"
  }, addressRow2), emailVerified && React.createElement("p", {
    className: "f-content margin-bottom-0"
  }, email));
};
const CustomerAddressInformation = _ref2 => {
  let className = _ref2.className;
  const _useCustomerPreferenc = useCustomerPreferences(),
    data = _useCustomerPreferenc.data,
    error = _useCustomerPreferenc.error,
    loading = _useCustomerPreferenc.loading;
  return React.createElement(CustomerAddressInformationComponent, {
    className: className,
    data: data,
    error: error,
    loading: loading
  });
};
setGlobal('svs.ticketsOrderHome.orderHome.components.CustomerAddressInformationComponent', CustomerAddressInformationComponent);
setGlobal('svs.ticketsOrderHome.orderHome.components.CustomerAddressInformation', CustomerAddressInformation);

 })(window);